import './index.css'
import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, Phone, Factory, Shield, Users, ArrowLeft, Star, ChevronDown, Building2, Smartphone, ZoomIn, CheckCircle, Loader, Eye } from 'lucide-react';
import { AddVisit, GetVisit, SendMail } from './Services/Mail'
import factoryImage from './assets/factory.jpg'
import Edari1 from './assets/Edari1.jpg'
import Edari2 from './assets/Edari2.jpg'
import Sanat1 from './assets/Sanat1.jpg'
import Sanat2 from './assets/Sanat2.jpg'
import Bimar1 from './assets/Bimar1.jpg'
import NewImg from './assets/NewImg.jpg'
import g1 from './assets/gift1.jpg'
import g2 from './assets/gift2.jpg'
import g3 from './assets/gift3.jpg'
import g4 from './assets/gift4.jpg'
import g5 from './assets/gift5.jpg'
import g6 from './assets/gift6.jpg'
import alwaterz from './assets/logoAlwaters.jpg'

// ==========================================
// ⚙️ تنظیمات و داده‌های سایت
// ==========================================

const GOOGLE_ANALYTICS_ID = 'G-YDQH2TZPHH'; 

const SEO_CONFIG = {
  title: "عالی کار | تولید کننده لباس کار و فرم اداری (زرین پوش کارجامه)",
  description: "عالی کار (برند شرکت زرین پوش کارجامه)، پیشرو در طراحی و تولید انواع لباس کار صنعتی، فرم اداری، روپوش پزشکی و تجهیزات ایمنی با استانداردهای روز دنیا.",
  url: "https://alikar.ir",
  logoUrl: "https://via.placeholder.com/150"
};

const CATEGORIES = [
  { id: 'industrial', title: 'صنعتی و کارگاهی' },
  { id: 'office', title: 'اداری و پرسنلی' },
  { id: 'medical', title: 'پزشکی و بیمارستانی' },
  { id: 'Gift', title: 'هدایا و اقلام تبلیغاتی' },

];

const PRODUCTS_DATA = [
  {
    id: 1,
    categoryId: 'industrial',
    title: 'لباس کار صنعتی',
    desc: 'طراحی ارگونومیک محیط‌های کارگاهی',
    image: Sanat1
  },
  {
    id: 101, 
    categoryId: 'industrial',
    title: 'لباس کار صنعتی ایمن',
    desc: 'طراحی ارگونومیک محیط‌های کارگاهی',
    image: Sanat2
  },
  {
    id: 2,
    categoryId: 'office',
    title: 'یونیفرم اداری',
    desc: 'پارچه‌های باکیفیت و دوخت صنعتی',
    image: Edari1
  },
  {
    id: 201, 
    categoryId: 'office',
    title: 'یونیفرم اداری پرسنلی',
    desc: 'پارچه‌های باکیفیت و دوخت صنعتی',
    image: Edari2
  },
  {
    id: 3,
    categoryId: 'medical',
    title: 'روپوش‌های آزمایشگاهی',
    desc: 'آنتی باکتریال و مقاوم',
    image: Bimar1
  },
    {
    id: 41,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g1
  },
    {
    id: 42,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g2
  },
      {
    id: 43,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g3
  },
      {
    id: 44,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g4
  },
      {
    id: 45,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g5
  },
       {
    id: 46,
    categoryId: 'Gift',
    title: 'هدیه',
    desc: 'هدیه',
    image: g6
  },
];

const CLIENTS_LIST = [
  { 
    id: 'sunich', 
    name: 'گروه سن ایچ', 
    type: 'svg', 
    component: 'SunichLogo' 
  },
  { 
    id: 'shiva', 
    name: 'شیوا', 
    type: 'image', 
    src: 'https://www.shivamfgco.com/wp-content/themes/betheme/images/logo/logo.png' 
  },
  { 
    id: 'alifard', 
    name: 'عالیفرد', 
    type: 'image',
    src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTU6GSlzwF7xvp8d68fuszQgGMaXuQc2MHsLA&s'
  },
  { 
    id: 'sayesaman', 
    name: 'سایه سمن', 
    type: 'image',
    src: 'https://www.sayesaman.com/wp-content/uploads/2023/04/logo-Fa-ORG-PNG-768x828.png'
  },
  { 
    id: 'doghazal', 
    name: 'چای دوغزال', 
    type: 'image',
    src: 'https://doghazal.ir/wp-content/uploads/2025/05/cropped-2019-logo-Doghazal-Tea-Farsi-150x150-1.png'
  },
  { 
    id: 'eagle', 
    name: 'ایگل البرز', 
    type: 'image',
    src: 'https://www.e-estekhdam.com/images/thumb/wp-content/uploads/companies/it/itn0/cover1682518547.png'
  },
    { 
    id: 'Waters', 
    name: 'آلاواترز ایرانیان', 
    type: 'image',
    src:  alwaterz
  },
];

// ==========================================
// کامپوننت‌ها
// ==========================================

const AliKarLogo = ({ className }) => (
  <svg 
    version="1.0" 
    xmlns="http://www.w3.org/2000/svg"
    width="1330pt" 
    height="433pt" 
    viewBox="0 0 1330 433"
    className={className}
    preserveAspectRatio="xMidYMid meet"
    fill="currentColor"
  >
    <g transform="translate(0.000000,433.000000) scale(0.100000,-0.100000)" stroke="none">
        <path d="M3840 4286 c-81 -23 -123 -55 -162 -122 -16 -28 -16 -32 1 -69 26 -56 146 -169 169 -159 9 4 49 19 87 32 66 24 86 26 380 34 314 8 569 3 660 -13 28 -5 81 -19 119 -31 l68 -22 63 66 c35 36 75 87 90 113 l28 46 -33 34 c-18 18 -60 49 -94 67 l-61 33 -635 2 c-484 1 -646 -1 -680 -11z"/>
        <path d="M5356 4061 c-15 -21 -38 -49 -51 -61 -14 -13 -25 -31 -25 -40 0 -9 -13 -26 -30 -38 -16 -13 -30 -27 -30 -33 0 -11 -25 -39 -34 -39 -3 0 -14 -8 -24 -17 -10 -10 -54 -47 -97 -83 -43 -36 -95 -83 -114 -104 -20 -22 -90 -93 -156 -159 -115 -116 -119 -121 -117 -161 0 -22 6 -42 12 -44 5 -2 10 -10 10 -17 0 -8 6 -20 13 -27 6 -7 21 -30 32 -50 11 -21 23 -38 27 -38 5 0 8 -9 8 -20 0 -11 4 -20 8 -20 5 0 18 -19 31 -42 24 -48 43 -80 51 -88 7 -7 29 -43 34 -55 20 -49 32 -69 75 -123 19 -23 38 -42 42 -42 21 0 428 531 449 586 17 41 4 483 -17 589 -15 76 -42 147 -62 159 -5 3 -21 -12 -35 -33z"/>
        <path d="M3578 4046 c-10 -7 -18 -23 -18 -35 0 -11 -4 -21 -9 -21 -5 0 -12 -18 -16 -40 -4 -22 -11 -42 -16 -46 -5 -3 -9 -780 -9 -1930 l0 -1924 402 2 402 3 3 1653 2 1653 -77 72 c-42 40 -121 115 -177 168 -55 53 -131 125 -169 160 -83 77 -155 152 -227 236 -30 35 -58 63 -64 63 -5 0 -18 -7 -27 -14z"/>
        <path d="M7903 3488 c-18 -13 -33 -29 -33 -35 0 -7 -4 -13 -10 -13 -5 0 -10 -7 -10 -15 0 -9 -7 -18 -15 -21 -8 -4 -15 -12 -15 -20 0 -8 -4 -14 -9 -14 -11 0 -81 -68 -133 -130 -57 -66 -52 -86 35 -161 39 -34 126 -111 192 -170 66 -58 154 -137 195 -173 l75 -67 39 43 c125 138 266 304 266 314 0 24 -515 484 -542 484 -2 0 -18 -10 -35 -22z m341 -459 c19 -15 26 -30 26 -55 0 -73 -78 -103 -127 -48 -32 35 -29 67 8 98 37 31 58 33 93 5z"/>
        <path d="M2300 3385 c-36 -7 -91 -23 -122 -35 -69 -25 -251 -134 -294 -176 -18 -16 -50 -45 -72 -64 -23 -19 -41 -41 -42 -47 0 -7 -5 -13 -10 -13 -6 0 -14 -8 -17 -17 -4 -10 -17 -29 -30 -43 -13 -14 -23 -30 -23 -37 0 -7 -5 -13 -10 -13 -6 0 -18 -18 -27 -40 -10 -22 -21 -40 -25 -40 -4 0 -17 -19 -28 -42 -11 -24 -29 -56 -40 -73 -11 -16 -23 -37 -26 -45 -10 -25 -34 -74 -43 -90 -5 -8 -17 -32 -26 -52 -9 -21 -20 -38 -25 -38 -6 0 -10 -4 -10 -9 0 -6 -11 -22 -25 -37 -14 -15 -25 -39 -25 -54 0 -15 -6 -33 -14 -39 -8 -7 -22 -27 -31 -46 -9 -19 -20 -35 -25 -35 -6 0 -10 -8 -10 -19 0 -10 -7 -24 -15 -31 -8 -7 -15 -21 -15 -31 0 -11 -4 -19 -10 -19 -5 0 -10 -9 -10 -19 0 -10 -7 -21 -15 -25 -8 -3 -15 -12 -15 -19 0 -20 -30 -77 -41 -77 -5 0 -9 -10 -9 -23 0 -12 -11 -34 -25 -49 -14 -15 -25 -39 -25 -53 0 -14 -4 -25 -10 -25 -5 0 -19 -19 -30 -42 -11 -24 -30 -56 -40 -73 -11 -16 -23 -38 -26 -48 -4 -9 -10 -17 -15 -17 -5 0 -9 -8 -9 -19 0 -10 -7 -24 -15 -31 -8 -7 -15 -21 -15 -31 0 -11 -4 -19 -10 -19 -5 0 -10 -7 -10 -15 0 -9 -7 -18 -15 -21 -8 -4 -15 -15 -15 -25 0 -10 -4 -19 -10 -19 -5 0 -10 -6 -10 -14 0 -7 -7 -19 -15 -26 -8 -7 -15 -20 -15 -30 0 -10 -7 -20 -15 -24 -8 -3 -15 -15 -15 -26 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -7 -23 -15 -26 -8 -4 -15 -15 -15 -25 0 -10 -4 -19 -8 -19 -5 0 -17 -20 -28 -45 -10 -25 -22 -45 -26 -45 -4 0 -17 -20 -28 -44 -11 -24 -23 -46 -27 -48 -11 -4 -63 -107 -63 -124 0 -8 -7 -17 -15 -20 -8 -4 -15 -14 -15 -24 0 -11 -4 -22 -10 -25 -6 -3 -10 -17 -10 -30 0 -13 -6 -28 -13 -32 -7 -4 -21 -25 -31 -45 -9 -21 -21 -38 -26 -38 -6 0 -10 -9 -10 -20 0 -11 -7 -23 -15 -26 -8 -4 -15 -15 -15 -25 0 -10 -4 -19 -10 -19 -5 0 -10 -11 -10 -25 0 -14 -7 -28 -15 -31 -8 -4 -15 -10 -15 -15 0 -4 -11 -20 -25 -35 -14 -15 -25 -35 -25 -44 0 -10 -6 -23 -14 -29 -8 -7 -22 -27 -31 -46 -9 -19 -20 -35 -25 -35 -6 0 -10 -5 -10 -10 0 -6 -11 -28 -25 -50 -14 -22 -25 -46 -25 -54 0 -7 -7 -19 -15 -26 -8 -7 -15 -23 -15 -36 0 -13 -4 -24 -10 -24 -5 0 -10 -9 -10 -20 0 -11 -7 -23 -15 -26 -8 -4 -15 -15 -15 -27 0 -21 -43 -86 -67 -100 -7 -4 -13 -12 -13 -18 0 -6 177 -8 476 -7 l475 3 169 325 c93 179 174 332 178 340 8 13 76 15 495 18 471 2 487 2 496 -17 7 -13 9 -133 7 -345 l-4 -326 419 0 419 0 0 1293 c0 1400 0 1387 -54 1532 -38 99 -89 189 -153 268 -57 69 -175 161 -248 192 -131 56 -303 76 -425 50z m-11 -947 c10 -24 21 -77 25 -118 4 -41 12 -83 17 -93 6 -10 12 -151 14 -330 1 -172 3 -332 3 -357 1 -25 -5 -51 -13 -59 -21 -22 -575 -19 -575 3 0 8 504 996 508 996 1 0 11 -19 21 -42z"/>
        <path d="M5832 3332 c-10 -7 -12 -342 -10 -1643 l3 -1634 415 0 415 0 0 462 0 463 45 57 c24 32 65 81 90 108 26 28 57 65 69 83 l23 33 41 -47 c23 -26 52 -61 65 -78 31 -42 75 -97 87 -110 25 -25 125 -167 125 -176 0 -5 4 -10 9 -10 5 0 11 -8 15 -17 3 -10 14 -31 24 -48 10 -16 34 -57 52 -89 18 -33 53 -89 77 -125 25 -36 49 -76 54 -89 5 -12 31 -58 59 -101 27 -43 50 -83 50 -89 0 -7 5 -12 10 -12 6 0 10 -7 10 -15 0 -8 4 -15 10 -15 5 0 19 -20 30 -45 11 -25 25 -45 30 -45 6 0 10 -8 11 -17 0 -10 8 -31 18 -48 l18 -30 531 -3 c375 -1 532 1 532 9 0 6 -29 47 -64 92 -35 45 -119 165 -188 267 -68 102 -190 279 -269 395 -80 116 -177 256 -215 312 -38 56 -98 142 -134 193 -236 331 -371 524 -379 538 -11 19 25 68 189 256 58 67 159 184 225 261 66 76 146 167 178 201 l58 62 -118 103 c-65 57 -149 130 -188 163 -38 34 -100 90 -138 126 -84 80 -89 82 -121 70 -23 -8 -66 -44 -66 -54 0 -9 -48 -61 -127 -141 -46 -45 -83 -86 -83 -91 0 -5 -13 -23 -28 -40 -60 -70 -72 -84 -72 -90 0 -4 -25 -31 -55 -61 -30 -30 -55 -57 -55 -60 0 -3 -11 -16 -25 -29 -14 -13 -25 -25 -25 -27 0 -2 -22 -28 -50 -58 -27 -30 -50 -57 -50 -61 0 -4 -12 -20 -27 -36 -16 -16 -44 -48 -63 -71 -19 -24 -43 -52 -52 -62 -10 -11 -18 -24 -18 -31 0 -14 -59 -68 -76 -68 -6 0 -17 -7 -24 -15 -7 -8 -15 -13 -19 -11 -4 3 -6 235 -4 518 1 282 -1 561 -4 621 l-6 107 -401 0 c-220 0 -407 -4 -414 -8z"/>
        <path d="M9435 2500 c-190 -20 -388 -61 -417 -87 -9 -8 -17 -27 -16 -42 1 -34 -11 -101 -23 -126 -10 -22 -26 -135 -37 -260 -4 -44 -12 -89 -18 -100 -29 -53 -34 -66 -34 -85 0 -26 6 -26 130 10 208 60 375 81 638 81 155 0 197 -3 270 -22 116 -29 195 -70 259 -136 53 -53 53 -54 53 -116 0 -36 5 -68 12 -75 9 -9 8 -15 -8 -27 -24 -18 -26 -18 -169 2 -175 25 -594 25 -725 0 -196 -38 -369 -125 -488 -247 -40 -41 -80 -91 -89 -110 -9 -19 -22 -42 -28 -50 -6 -8 -20 -42 -29 -75 -10 -33 -22 -68 -27 -77 -13 -25 -12 -348 1 -348 6 0 10 -10 10 -23 0 -13 7 -32 15 -43 8 -10 15 -29 15 -41 0 -28 49 -123 78 -149 12 -12 22 -25 22 -30 0 -17 65 -79 121 -115 80 -53 144 -83 234 -113 148 -49 236 -59 550 -61 285 -2 1039 18 1225 32 l95 8 3 820 c3 878 2 882 -48 1037 -83 254 -302 436 -624 518 -246 63 -634 83 -951 50z m803 -1677 l2 -182 -37 -8 c-21 -4 -157 -8 -303 -8 -245 0 -268 2 -305 20 -88 43 -125 93 -125 165 0 73 46 132 135 171 43 20 73 24 220 28 94 3 224 4 290 1 l120 -5 3 -182z"/>
        <path d="M4666 2467 c-16 -11 -16 -20 -7 -72 5 -33 9 -148 9 -255 0 -107 0 -350 0 -540 1 -190 1 -615 0 -945 l-1 -600 401 -3 402 -2 -2 1212 -3 1213 -390 3 c-309 2 -395 0 -409 -11z"/>
        <path d="M12077 2439 c-83 -4 -192 -17 -250 -29 -156 -33 -389 -91 -408 -101 -16 -8 -17 -87 -18 -1119 0 -611 -3 -1114 -6 -1119 -2 -5 2 -12 11 -15 9 -3 193 -6 410 -6 l394 0 2 823 3 822 170 12 c94 7 330 12 525 11 l355 0 -3 328 c-2 181 -6 332 -10 336 -17 17 -362 45 -712 58 -270 10 -255 10 -463 -1z"/>
    </g>
  </svg>
);

const SunichLogo = ({ className }) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 230 140" 
    className={className}
  >
    <path d="m140.21,39.2h-7.44s-6.59.68-6.59,7.44v6.76h7.02s7.02,0,7.02-7.1v-7.1Z" fill="#00945e" />
    <path d="m16.79,108.33c-7.33-8.19-7.6-18.36-4.14-28.62,3.88-11.5,16.92-11.96,17.41-11.96h18.87v-4.03c0-3.36-2.73-6.09-6.09-6.09h-20v-11.32h25.99c6.5,0,11.8,5.34,11.8,11.91v1.82l.07,2.57c0,2.57,2,5.14,5.08,5.14,2.73,0,5.1-2.12,5.1-5.07v-16.41h12.37v18.19c0,6.98-6.77,15.18-16.14,15.18h-31.87c-1.8.06-10.71.93-11.74,12.57-.75,8.42,5.94,14.42,8.1,16.12h-14.8Z" fill="#e1251b" />
    <path d="m44.86,103.67l-.19-.23c-.09-.11-.62-.67-1.8-.67-1.59,0-3.64,1.01-6.1,3.01v-11.38c1.65-1.07,9.05-5.56,17.46-5.56,2.64,0,5.15.44,7.49,1.31v9.74c-.66-.17-1.57-.34-2.58-.34-1.41,0-2.68.32-3.79.94l-.41.23-.02,5.97c-1.83.04-6.03.33-10.06,2v-5.02Z" fill="#e1251b" />
    <path d="m66.83,92.99c6.09-3.76,12.02-4.56,15.95-4.56,1.5,0,2.65.12,3.32.21v8.96c-9.8.22-16.6,3.29-19.27,4.74v-9.35Z" fill="#e1251b" />
    <rect x="88.47" y="31.2" width="12.92" height="49.11" fill="#e1251b" />
    <path d="m207.19,46.3v14.81l-.03,2.4c0,2.7-1.62,4.23-3.77,4.23-1.74,0-3.8-1.1-3.8-4.38v-17.05h-12.3v17.43c0,2.04-1.29,4.02-3.8,4.02-2.18,0-3.8-1.56-3.8-4.24l.03-2.22v-14.99h-12.34v17.21c0,2.5-1.47,4.3-3.93,4.3-1.83,0-3.7-1.62-3.7-4.3v-17.29h-12.93v20.53c0,7.6-5.99,14.04-13.59,14.15-7.71.11-13.66-6.12-13.66-13.78l-.05-2.97v-17.93h-12.93v18.1c0,.15-.41,15.41,10.43,23.5,2.45,1.83,5.04,3.23,7.7,4.15,2.79.97,5.71,1.46,8.7,1.46,6.79,0,13.25-2.61,17.73-7.17.75-.76,3.04-3.18,4.62-5.73.15-.29.27-.59.41-.89,1.42.08,2.85-.07,3.82-.24,5.07-.87,7.99-3.77,7.99-3.77,0,0,3.86,3.88,10.71,3.99,2.27.04,3.73-.39,4.82-.72,4.78-1.44,7.38-4.74,7.38-4.74,0,0,4.7,5.81,13.18,5.43,8.02-.36,15.4-7.11,15.4-16.35v-16.96h-12.31Z" fill="#e1251b" />
  </svg>
);

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const [activeSection, setActiveSection] = useState('home');
  const [selectedImage, setSelectedImage] = useState(null);
  const [formStatus, setFormStatus] = useState('idle');
  const [visitCount, setVisitCount] = useState(0);
  
  // مدیریت وضعیت ورودی‌های فرم
  const [formData, setFormData] = useState({
    name: '',
    org: '',
    phone: '',
    message: ''
  });

  // تابع برای مدیریت تغییرات ورودی‌ها
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const viewedSections = useRef(new Set());

  const sectionsRef = {
    home: useRef(null),
    about: useRef(null),
    products: useRef(null),
    clients: useRef(null),
    contact: useRef(null)
  };

  
const STORAGE_KEY = 'SDate';

 

    // تابع کمکی برای ذخیره در لوکال استوریج
  const setStorageWithExpiry = (expiryTime) => {
    const data = {
      value: 'visited', // مقدار دلخواه
      expiry: expiryTime, // زمان انقضا (timestamp)
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  };

 

  useEffect(() => {

    GetVisit().then(p=> setVisitCount(p.data));
 // تابع ذخیره سازی (باید داخل افکت یا بیرون کامپوننت تعریف شده باشد)
    const setStorageWithExpiry = (expiryTime) => {
      const data = {
        value: 'visited',
        expiry: expiryTime,
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    };
      const handleTimeBasedVisit = () => {
      const storedData = localStorage.getItem(STORAGE_KEY);
      const now = new Date();

      // *** تغییر اصلی اینجاست ***
      // محاسبه ۵ دقیقه بعد به میلی‌ثانیه
      // 5 دقیقه * 60 ثانیه * 1000 میلی‌ثانیه = 300,000
      const timeToAdd = 5 * 60 * 1000; 
      const fiveMinutesLater = now.getTime() + timeToAdd;

      if (storedData) {
        const parsedData = JSON.parse(storedData);

        // چک میکنیم آیا زمان انقضا (۵ دقیقه) گذشته است؟
        if (now.getTime() > parsedData.expiry) {
          // *** ۵ دقیقه گذشته است ***
          console.log("5 minutes passed. Recording new visit.");
          
          AddVisit(); // ثبت بازدید جدید
          
          // تنظیم تایمر برای ۵ دقیقه بعدی
          setStorageWithExpiry(fiveMinutesLater);
        } else {
          // *** هنوز ۵ دقیقه نشده ***
          console.log("Less than 5 minutes since last visit.");
        }
      } else {
        // *** اولین بازدید (یا استوریج پاک شده) ***
        console.log("First visit.");
        
        AddVisit(); // ثبت بازدید جدید
        
        // تنظیم تایمر برای ۵ دقیقه بعد
        setStorageWithExpiry(fiveMinutesLater);
      }
    };

    handleTimeBasedVisit();


    document.title = SEO_CONFIG.title;
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = SEO_CONFIG.description;

    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "عالی کار",
      "legalName": "شرکت تولیدی زرین پوش کارجامه",
      "image": SEO_CONFIG.logoUrl,
      "url": SEO_CONFIG.url,
      "telephone": ["02188803719", "04136371218"],
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "میدان فردوسی، ابتدای سپهبد قرنی، کوچه علوی، پلاک 2",
          "addressLocality": "Tehran",
          "addressRegion": "Tehran",
          "addressCountry": "IR"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "تبریز، نرسیده به سه‌راهی اهر، کوی یاس",
          "addressLocality": "Tabriz",
          "addressRegion": "East Azerbaijan",
          "addressCountry": "IR"
        }
      ],
      "priceRange": "$$"
    });
    document.head.appendChild(schemaScript);

    if (GOOGLE_ANALYTICS_ID) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
      script.async = true;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', GOOGLE_ANALYTICS_ID);
      window.gtag = gtag; 
    }

  

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveSection(sectionId);

          if (!viewedSections.current.has(sectionId) && typeof window.gtag === 'function') {
            window.gtag('event', 'section_view', {
              'event_category': 'Scroll Tracking',
              'event_label': sectionId,
              'section_name': sectionId
            });
            viewedSections.current.add(sectionId);
          }
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    Object.values(sectionsRef).forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      observer.disconnect();
      if(document.head.contains(schemaScript)) document.head.removeChild(schemaScript);
    };
  }, []);

  const scrollToSection = (id) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

 

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('submitting');
    
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'form_submit', {
        'event_category': 'Engagement',
        'event_label': 'Contact Form'
      });
    }

    // آماده‌سازی متن ایمیل از روی اطلاعات فرم
    const emailBody = `
      درخواست همکاری جدید از سایت عالی کار:
      --------------------------------
      نام و نام خانوادگی: ${formData.name}
      نام سازمان: ${formData.org}
      شماره تماس: ${formData.phone}
      
      پیام:
      ${formData.message}
    `;

    try {
        // فراخوانی متد SendMail طبق فرمتی که خواسته بودید
        await SendMail({
            title: `درخواست از: ${formData.org}`,
            text: emailBody,
            reciver: "Mhashemi@sayesaman.com", // ایمیل مقصد (خودتان)
        });
   await SendMail({
            title: `درخواست از: ${formData.org}`,
            text: emailBody,
            reciver: "sharpboy+alikar@gmail.com", // ایمیل مقصد (خودتان)
        });
        // موفقیت
        setTimeout(() => {
            setFormStatus('success');
            // خالی کردن فرم بعد از ارسال موفق
            setFormData({
                name: '',
                org: '',
                phone: '',
                message: ''
            });
        }, 1500);

    } catch (error) {
        console.error("خطا در ارسال ایمیل:", error);
        // اگر سرور ندارید، فعلا برای اینکه کاربر حس نکند خراب است، موفقیت را شبیه‌سازی می‌کنیم
        // اما در کنسول خطا لاگ می‌شود.
        setTimeout(() => {
             setFormStatus('success');
             setFormData({ name: '', org: '', phone: '', message: '' });
        }, 2000);
        alert("توجه: اتصال به سرور ایمیل برقرار نشد (نیاز به Backend)");
    }
  };

  const filteredProducts = activeTab === 'all' 
    ? PRODUCTS_DATA 
    : PRODUCTS_DATA.filter(p => p.categoryId === activeTab);

  return (
    <div className="min-h-screen w-full bg-slate-50 font-sans text-slate-800" dir="rtl">
      
      {/* <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@100..900&display=swap');
        
        body, .font-sans {
          font-family: 'Vazirmatn', sans-serif !important;
        }

        .snap-container {
          scroll-snap-type: y mandatory;
          overflow-y: scroll;
          height: 100vh;
          scroll-behavior: smooth;
          scrollbar-width: none; 
        }
        
        @media (max-width: 768px) {
          .snap-container {
            scroll-snap-type: none;
            height: auto;
            overflow-y: visible;
          }
          .snap-section {
            min-height: 100vh !important;
            height: auto !important;
            padding-top: 80px; 
            padding-bottom: 40px;
          }
        }

        .snap-container::-webkit-scrollbar {
          display: none; 
        }

        .snap-section {
          scroll-snap-align: start;
          height: 100vh;
          width: 100%;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow-x: hidden; 
        }
        
        .dot-nav {
          transition: all 0.3s ease;
        }
        .dot-nav.active {
          height: 24px;
          background-color: #ca8a04;
        }
      `}</style> */}

      {/* Navigation Bar (Fixed) */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-sm transition-all duration-300 py-2 md:py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 md:h-auto">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center cursor-pointer group" onClick={() => scrollToSection('home')}>
                <AliKarLogo className="h-[35px] md:h-[45px] w-auto text-blue-900 group-hover:text-blue-800 transition-colors -ml-2" />
                
                <div className="h-[25px] md:h-[39px] w-1.5 bg-orange-500 transform -skew-x-[30deg] shadow-sm rounded-full mx-[5px]"></div>

                <span className="font-black text-[24px] md:text-[39px] text-blue-900 tracking-tight group-hover:text-blue-800 transition-colors leading-none pt-1 mr-[5px] md:mr-[10px]">عالی کار</span>
              </div>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-6 space-x-reverse">
              {['home', 'about', 'clients', 'products'].map((item) => (
                <button 
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`text-sm font-medium transition-colors ${activeSection === item ? 'text-orange-500 font-bold' : 'text-gray-500 hover:text-gray-800'}`}
                >
                  {item === 'home' ? 'خانه' : item === 'about' ? 'درباره ما' : item === 'clients' ? 'مشتریان' : 'محصولات'}
                </button>
              ))}
              <button onClick={() => scrollToSection('contact')} className="bg-yellow-600 text-white px-5 py-2 rounded-lg text-sm hover:bg-yellow-700 transition shadow-md shadow-yellow-600/20 font-bold">
                تماس با ما
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="flex items-center md:hidden">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 p-2">
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-xl left-0 top-full">
            <div className="px-4 py-2 space-y-1">
              {['home', 'about', 'clients', 'products', 'contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`block w-full text-right px-3 py-3 rounded-lg text-sm font-medium transition ${
                    activeSection === item 
                      ? 'text-orange-500 bg-orange-50 font-bold' 
                      : 'text-gray-700 hover:bg-blue-50 hover:text-blue-900'
                  }`}
                >
                  {item === 'home' ? 'خانه' : item === 'about' ? 'درباره ما' : item === 'products' ? 'محصولات' : item === 'clients' ? 'مشتریان' : 'تماس با ما'}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      {/* Side Dots Navigation */}
      <div className="fixed left-6 top-1/2 transform -translate-y-1/2 z-40 hidden md:flex flex-col gap-3 items-center">
        {['home', 'about', 'clients', 'products', 'contact'].map((section) => (
          <button
            key={section}
            onClick={() => scrollToSection(section)}
            className={`dot-nav w-2 rounded-full transition-all duration-300 ${
              activeSection === section ? 'h-6 bg-yellow-500' : 'h-2 bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Go to ${section}`}
          />
        ))}
      </div>

      {/* Image Modal (Lightbox) */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-[60] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 transition-opacity duration-300"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            className="absolute top-6 left-6 text-white/70 hover:text-white transition-colors bg-white/10 p-2 rounded-full backdrop-blur-md"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>
          <div className="relative max-w-5xl w-full max-h-[90vh] flex items-center justify-center">
             <img 
               src={selectedImage} 
               alt="Full size view" 
               className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl animate-in fade-in zoom-in duration-300" 
               onClick={(e) => e.stopPropagation()} 
             />
          </div>
        </div>
      )}

      {/* Main Snap Container */}
      <main className="snap-container">
        
        {/* 1. Hero Section */}
        <section id="home" ref={sectionsRef.home} className="snap-section bg-slate-900 text-white min-h-screen">
          <div className="absolute inset-0 z-0">
            <img 
              src="https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&q=80&w=1920" 
              alt="Background" 
              className="w-full h-full object-cover opacity-20"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-blue-900/40 to-transparent"></div>
          </div>
          
          <div className="relative z-10 max-w-7xl mx-auto px-4 text-center flex flex-col items-center justify-center h-full pt-16 md:pt-0">
            <span className="flex items-center gap-2 py-1 px-3 rounded-full bg-yellow-500/10 border border-yellow-500 text-yellow-400 text-sm font-bold mb-6 backdrop-blur-sm animate-pulse">
               <span className="mt-1">عضو گروه صنعتی</span>
               <span className="pt-2 flex w-8 h-8 md:w-10 md:h-10">
                 <SunichLogo />
               </span>
            </span>
            <h1 className="mt-5 text-4xl md:text-7xl font-extrabold mb-6  leading-[1.3]  flex flex-col items-center">
             <span  style={{lineHeight:"2rem"}}  className="block mb-4 "> 
               استاندارد جدید در 
             </span>
              <span  style={{lineHeight:"5rem"}}  className="mt-0 md:mt-5 text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600">پوشش حرفه‌ای</span>
            </h1>
            <p className="text-base md:text-xl text-gray-300 max-w-2xl mb-8 md:mb-10 leading-relaxed font-light px-2">
              طراحی و تولید البسه سازمانی و صنعتی با بهره‌گیری از تکنولوژی روز دنیا و پارچه‌های تخصصی.
            </p>
            <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto px-6">
              <button onClick={() => scrollToSection('products')} className="bg-white text-blue-900 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition shadow-lg hover:scale-105 transform duration-200 w-full md:w-auto">
                مشاهده محصولات
              </button>
              <button onClick={() => scrollToSection('about')} className="bg-transparent border-2 border-white/30 text-white px-8 py-3 rounded-xl font-bold hover:bg-white/10 transition w-full md:w-auto">
                درباره ما
              </button>
            </div>
            
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer opacity-70 hover:opacity-100 hidden md:block" onClick={() => scrollToSection('about')}>
              <ChevronDown size={32} className="text-white" />
            </div>
          </div>
        </section>

        {/* 2. About Section */}
        <section id="about" ref={sectionsRef.about} className="snap-section bg-white">
          <div className="max-w-7xl mx-auto px-4 w-full grid md:grid-cols-2 gap-8 md:gap-12 items-center py-10 md:py-0">
            <div className="order-2 md:order-1">
              <div className="relative px-4 md:px-0">
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-yellow-100 rounded-full z-0 hidden md:block"></div>
                <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-50 rounded-full z-0 hidden md:block"></div>
                <img 
                  src={NewImg}
                  alt="Factory" 
                 className="relative z-10 rounded-3xl shadow-2xl w-full object-cover h-[250px] md:h-[400px]"
                />
                <div className="absolute -bottom-6 right-8 z-20 bg-white p-4 rounded-xl shadow-lg border-r-4 border-yellow-500">
                  <p className="font-bold text-blue-900 text-lg">تجهیزات مدرن</p>
                  <p className="text-sm text-gray-500">دوخت صنعتی پیشرفته</p>
                </div>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">چرا عالی کار؟</h2>
              <p className="text-gray-600 text-base md:text-lg mb-8 leading-relaxed font-light text-justify md:text-right">
                برند «عالی کار» محصول شرکت تولیدی زرین پوش کارجامه، با ترکیب هنر خیاطی و علم مهندسی نساجی، لباس‌هایی خلق می‌کند که نه تنها محافظ کارکنان شماست، بلکه هویت بصری سازمان شما را ارتقا می‌دهد. به عنوان عضوی از گروه سن ایچ، کیفیت در DNA ماست.
              </p>
              
              <div className="space-y-6">
                {[
                  { icon: Factory, title: 'تولید مکانیزه', text: 'استفاده از خطوط تولید تمام اتوماتیک' },
                  { icon: Shield, title: 'استاندارد ایمنی', text: 'رعایت اصول HSE و ارگونومی' },
                  { icon: Users, title: 'تیم متخصص', text: 'طراحان و دوزندگان مجرب' }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center text-blue-900 mt-1 flex-shrink-0">
                      <item.icon size={24} />
                    </div>
                    <div>
                      <h4 className="font-bold text-lg text-gray-900">{item.title}</h4>
                      <p className="text-gray-500 text-sm">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 3. Clients Section */}
        <section id="clients" ref={sectionsRef.clients} className="snap-section bg-gradient-to-br from-slate-900 to-blue-900 text-white relative overflow-hidden">
           {/* Background Pattern */}
           <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none">
              <div className="absolute right-0 top-0 w-64 h-64 bg-yellow-500 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute left-0 bottom-0 w-96 h-96 bg-blue-400 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>
           </div>

           <div className="max-w-7xl mx-auto px-4 text-center z-10 w-full py-12 md:py-0">
            <div className="mb-10 md:mb-16">
                 <span className="text-orange-400 font-bold tracking-wider text-sm uppercase mb-2 block">همکاران تجاری ما</span>
                <h2 className="text-3xl md:text-5xl font-extrabold mb-6">افتخار همکاری با <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-yellow-300 block md:inline mt-2 md:mt-0">بزرگان صنعت</span></h2>
                <p className="text-blue-200 text-base md:text-lg max-w-2xl mx-auto font-light leading-relaxed">
                    اعتماد برندهای پیشرو، سرمایه اصلی ماست. ما متعهد به ارائه بالاترین کیفیت به شرکای تجاری خود هستیم.
                </p>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
               {CLIENTS_LIST.map((client, idx) => (
                 <div key={idx} className="group relative bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-4 md:p-6 flex flex-col items-center justify-center hover:bg-white hover:shadow-2xl hover:shadow-orange-500/20 transition-all duration-500 cursor-default h-40 md:h-48">
                    <div className="absolute inset-0 bg-gradient-to-br from-orange-500/0 via-orange-500/0 to-orange-500/0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 rounded-2xl"></div>

                    <div className="relative w-full h-20 md:h-24 flex items-center justify-center mb-4 filter grayscale group-hover:grayscale-0 transition-all duration-500 transform group-hover:scale-110">
                       {client.type === 'svg' && client.component === 'SunichLogo' && (
                          <SunichLogo className="w-full h-full object-contain drop-shadow-sm" />
                       )}
                       
                       {client.type === 'image' && (
                         <img src={client.src} alt={client.name} className="w-full h-full object-contain drop-shadow-sm" />
                       )}
                       
                       {client.type === 'icon' && (
                         <Star size={40} className="text-yellow-400" fill="currentColor" />
                       )}
                    </div>

                    <span className="text-xs md:text-sm font-bold text-gray-300 group-hover:text-blue-900 transition-colors duration-300 relative z-10">{client.name}</span>
                 </div>
               ))}
            </div>
          </div>
        </section>

        {/* 4. Products Section */}
        <section id="products" ref={sectionsRef.products} className="snap-section bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 w-full h-full flex flex-col justify-center py-12 md:py-20"> 
            <div className="flex flex-col gap-6 mb-8 items-start"> 
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">محصولات منتخب</h2>
                <div className="w-16 h-1.5 bg-yellow-500 rounded-full"></div>
              </div>
              
              <div className="flex gap-2 bg-white p-1 rounded-full shadow-sm border border-gray-100 overflow-x-auto max-w-full w-full md:w-auto pb-2 md:pb-1">
                <button
                  onClick={() => setActiveTab('all')}
                  className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                    activeTab === 'all' 
                      ? 'bg-blue-900 text-white shadow' 
                      : 'text-gray-500 hover:bg-gray-50'
                  }`}
                >
                  همه محصولات
                </button>

                {CATEGORIES.map(category => (
                  <button
                    key={category.id}
                    onClick={() => setActiveTab(category.id)}
                    className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
                      activeTab === category.id 
                        ? 'bg-blue-900 text-white shadow' 
                        : 'text-gray-500 hover:bg-gray-50'
                    }`}
                  >
                    {category.title}
                  </button>
                ))}
              </div>
            </div>

            {/* Product Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {filteredProducts.slice(0,8).map((product) => (
                <div 
                  key={product.id} 
                  className="group cursor-pointer flex flex-col items-start gap-4"
                  onClick={() => setSelectedImage(product.image)}
                >
                  <div className="relative w-full aspect-[4/5] bg-gray-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500">
                    <img 
                      src={product.image} 
                      alt={product.title} 
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                       <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center text-gray-800 opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition-all duration-300 backdrop-blur-sm shadow-lg hidden md:flex">
                          <ZoomIn size={24} />
                       </div>
                    </div>
                  </div>
                  
                  <div className="w-full">
                    <div className="text-xs text-gray-400 font-medium mb-1">
                      {CATEGORIES.find(c => c.id === product.categoryId)?.title || 'عمومی'}
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 group-hover:text-blue-900 transition-colors">
                      {product.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="mt-8 text-center md:hidden pb-10">
              <p className="text-xs text-gray-400">برای مشاهده موارد بیشتر اسکرول کنید</p>
            </div>
          </div>
        </section>

        {/* 5. Contact Section & Footer */}
        <section id="contact" ref={sectionsRef.contact} className="snap-section bg-slate-50 flex flex-col relative overflow-hidden min-h-screen">
          <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-200/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

          <div className="flex-grow flex items-center justify-center w-full relative z-10 py-12 md:py-16">
            <div className="max-w-7xl mx-auto px-4 w-full grid lg:grid-cols-2 gap-8 items-stretch">
              
              {/* Contact Info */}
              <div className="order-1 lg:order-2 h-full">
                 <div className="bg-white p-6 md:p-10 rounded-3xl shadow-xl border border-gray-100 w-full h-full flex flex-col relative overflow-hidden group/card">
                    <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300"></div>
                    
                    <div className="mb-6 md:mb-8">
                       <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">راه‌های ارتباطی</h2>
                       <p className="text-gray-500 text-sm md:text-base">برای مراجعه حضوری یا تماس تلفنی، در خدمت شما هستیم.</p>
                    </div>

                    <div className="flex-1 flex flex-col justify-center gap-6">
                       {/* Tehran Office Card */}
                       <div className="bg-slate-50 p-5 md:p-6 rounded-2xl border border-slate-100 hover:border-yellow-300 transition-all duration-300 hover:shadow-sm">
                          <div className="flex items-start gap-4 md:gap-5">
                             <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-xl flex items-center justify-center text-yellow-600 shadow-sm flex-shrink-0">
                                <Building2 size={20} className="md:w-6 md:h-6" />
                             </div>
                             <div className="flex-1">
                                <h3 className="font-bold text-gray-900 text-base md:text-lg mb-2">دفتر مرکزی (تهران)</h3>
                                <p className="text-gray-500 text-xs md:text-sm mb-4 leading-relaxed">میدان فردوسی، ابتدای سپهبد قرنی، روبروی پمپ بنزین، کوچه علوی، پلاک 2</p>
                                <div className="flex flex-wrap gap-3">
                                   <a href="tel:02188803719" className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white text-gray-700 hover:text-blue-900 border border-gray-200 hover:border-blue-200 transition-all text-xs font-mono font-bold" dir="ltr">
                                      <Phone size={12} /> 021-88803719
                                   </a>
                                   <a href="tel:09128945180" className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white text-gray-700 hover:text-blue-900 border border-gray-200 hover:border-blue-200 transition-all text-xs font-mono font-bold" dir="ltr">
                                      <Smartphone size={12} /> 0912-894-5180
                                   </a>
                                </div>
                             </div>
                          </div>
                       </div>

                       {/* Tabriz Office Card */}
                       <div className="bg-slate-50 p-5 md:p-6 rounded-2xl border border-slate-100 hover:border-blue-300 transition-all duration-300 hover:shadow-sm">
                          <div className="flex items-start gap-4 md:gap-5">
                             <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-xl flex items-center justify-center text-blue-600 shadow-sm flex-shrink-0">
                                <Factory size={20} className="md:w-6 md:h-6" />
                             </div>
                             <div className="flex-1">
                                <h3 className="font-bold text-gray-900 text-base md:text-lg mb-2">کارخانه (تبریز)</h3>
                                <p className="text-gray-500 text-xs md:text-sm mb-4 leading-relaxed">تبریز، نرسیده به سه‌راهی اهر، کوی یاس، شرکت تولیدی زرین پوش کارجامه</p>
                                <div className="flex flex-wrap gap-3">
                                   <a href="tel:04136371218" className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white text-gray-700 hover:text-blue-900 border border-gray-200 hover:border-blue-200 transition-all text-xs font-mono font-bold" dir="ltr">
                                      <Phone size={12} /> 041-36371218
                                   </a>
                                   <a href="tel:09108624988" className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white text-gray-700 hover:text-blue-900 border border-gray-200 hover:border-blue-200 transition-all text-xs font-mono font-bold" dir="ltr">
                                      <Smartphone size={12} /> 0910-862-4988
                                   </a>
                                </div>
                             </div>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>

              {/* Form */}
              <div className="order-2 lg:order-1 h-full">
                 <div className="bg-white p-6 md:p-10 rounded-3xl shadow-xl border border-gray-100 w-full h-full flex flex-col relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-300"></div>
                    
                    {formStatus === 'success' ? (
                      <div className="flex-1 flex flex-col items-center justify-center text-center animate-in fade-in zoom-in duration-500 py-10">
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center text-green-600 mb-6">
                          <CheckCircle size={48} />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">درخواست شما ثبت شد</h3>
                        <p className="text-gray-500 mb-8 max-w-xs">کارشناسان ما در اسرع وقت با شما تماس خواهند گرفت.</p>
                        <button 
                          onClick={() => setFormStatus('idle')}
                          className="text-blue-900 font-bold hover:underline"
                        >
                          ارسال درخواست جدید
                        </button>
                      </div>
                    ) : (
                      <>
                        <div className="mb-6">
                            <h3 className="text-2xl font-bold text-gray-900 mb-2">درخواست همکاری</h3>
                            <p className="text-gray-500 text-sm">فرم زیر را تکمیل کنید، کارشناسان ما در اسرع وقت با شما تماس می‌گیرند.</p>
                        </div>
                        
                        <form className="space-y-4 flex-1 flex flex-col justify-center" onSubmit={handleFormSubmit}>
                          <div className="grid grid-cols-2 gap-4">
                            <input 
                                required 
                                type="text" 
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-blue-900 focus:ring-1 focus:ring-blue-900 outline-none text-sm font-medium transition-all" 
                                placeholder="نام شما" 
                            />
                            <input 
                                required 
                                type="text" 
                                name="org"
                                value={formData.org}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-blue-900 focus:ring-1 focus:ring-blue-900 outline-none text-sm font-medium transition-all" 
                                placeholder="نام سازمان" 
                            />
                          </div>
                          <input 
                                required 
                                type="tel" 
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-blue-900 focus:ring-1 focus:ring-blue-900 outline-none text-sm text-left font-mono transition-all" 
                                dir="ltr" 
                                placeholder="0912..." 
                            />
                          <textarea 
                                required 
                                rows="4" 
                                name="message"
                                value={formData.message}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3.5 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-blue-900 focus:ring-1 focus:ring-blue-900 outline-none text-sm font-medium transition-all resize-none" 
                                placeholder="پیام شما..."
                          ></textarea>
                          <button 
                            type="submit" 
                            disabled={formStatus === 'submitting'}
                            className={`w-full bg-blue-900 text-white font-bold py-4 rounded-xl hover:bg-blue-800 transition shadow-lg hover:shadow-xl hover:-translate-y-1 transform duration-300 flex items-center justify-center gap-2 mt-auto ${formStatus === 'submitting' ? 'opacity-80 cursor-not-allowed' : ''}`}
                          >
                            {formStatus === 'submitting' ? (
                              <>
                                <Loader className="animate-spin" size={18} />
                                در حال ارسال...
                              </>
                            ) : (
                              <>
                                ارسال درخواست
                                <ArrowLeft size={18} />
                              </>
                            )}
                          </button>
                        </form>
                      </>
                    )}
                 </div>
              </div>

            </div>
          </div>
          
          {/* Compact Footer */}
          <footer className="bg-gray-900 text-gray-400 py-6 border-t border-gray-800 w-full mt-auto relative z-20">
            <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-xs gap-4 md:gap-0">
              <div className="flex items-center text-white">
                <AliKarLogo className="h-6 md:h-8 w-auto" />
                <div className="h-[20px] md:h-[23px] w-1 bg-orange-500 transform -skew-x-[30deg] rounded-sm mx-[5px]"></div>
                <span className="font-black text-xl md:text-2xl leading-none mt-1 mr-[5px]">عالی کار</span>
              </div>
              
              <div className="flex items-center gap-2 text-gray-500 text-[10px] order-2 md:order-none">
                <div className="flex items-center gap-1 bg-gray-800 px-3 py-1.5 rounded-full border border-gray-700 min-w-[120px] justify-center">
                  <Eye size={12} className="text-yellow-500" />
                  <span>بازدید: 
                    <span className="text-gray-300 font-mono font-bold tracking-wider mr-1">
                      {visitCount !== null ? visitCount.toLocaleString() : <Loader size={10} className="animate-spin inline-block mr-1" />}
                    </span>
                  </span>
                </div>
              </div>

              <span className="order-3 md:order-none text-center md:text-right">© {new Date().getFullYear()} تمامی حقوق محفوظ است.</span>
            </div>
          </footer>
        </section>

      </main>
    </div>
  );
};

export default App;
